<template>
  <b-modal
    v-model="localIsActive"
    size="xl"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @hide="onHide"
    @show="onShow"
  >
    <template #modal-title>
      {{ modalTitle }}
    </template>
    <b-alert :show="showAlert" variant="warning" class="p-1">
      La vista esta en proceso de validación.
    </b-alert>

    <validation-observer v-slot="{ handleSubmit }">
      <b-form
        class="auth-login-form"
        @submit.prevent="handleSubmit(onSubmit)"
        ref="createVideoTour"
      >
        <b-row class="">
          <!-- NAME -->
          <b-col cols="8">
            <validation-provider
              name="name"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group
                class="text-capitalize mb-0"
                :label="$t('video_tour.name')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="item.name"
                  trim
                />
                <p v-if="errors" class="small text-danger">
                  {{ errors[0] }}
                </p>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="auto" class="align-self-center">
            <b-form-checkbox
              v-model="item.is_public"
              class="text-capitalize"
              switch
            >
              Es publica
            </b-form-checkbox>
          </b-col>
          <b-col
            v-if="showSubmitButton"
            cols="auto"
            class="d-flex align-items-center"
          >
            <b-button
              type="submit"
              variant="primary"
              class="text-capitalize"
              :disabled="loading"
            >
              {{ buttonText }}
            </b-button>
          </b-col>
          <b-col
            v-if="showSendToValidationButton"
            cols="auto"
            class="d-flex align-items-center"
          >
            <b-button
              variant="primary"
              class="text-capitalize"
              :disabled="loading"
              @click="sendToValidation()"
            >
              Mandar a revisión
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <div class="row mx-0 justify-content-between mb-1">
      <div class="col-5 pl-0">
        <span class="font-weight-bold h5 videoTourDualListTitle">
          {{ $t('video_tour.layouts_list') }}
        </span>
        <b-input-group class="w-100 my-1">
          <b-input-group-prepend is-text>
            <i class="feather icon-search"></i>
          </b-input-group-prepend>

          <b-form-input
            id="searchView"
            v-model="layoutsSearch"
            trim
            :placeholder="$t('search')"
            @input="onTypeSearch"
          />
        </b-input-group>
        <div class="row">
          <div
            v-for="(layout, index) in layouts"
            :key="index"
            class="col-4 mb-1"
            @click="addPreview(layout)"
          >
            <layout-preview
              :key="`${layout.id}-${JSON.stringify(layout.grid || layout.data)}`"
              :layout="layout"
            />
          </div>
        </div>
        <pagination-widgets
          :sidebarMinWidthReached="false"
          :per-page.sync="layoutsPerPage"
          :records-per-page="[3]"
          :current-page.sync="layoutsCurrentPage"
          :total-records="layoutsViewsTotalRecords"
          @update:currentPage="updateLayoutsCurrentPage"
          @update:perPage="updateLayoutsPerPage"
        />

      </div>
      <div class="col-6">
        <p class="mb-0">{{ $t('video_tour.preview') }}</p>
        <div class="d-flex mt-1  justify-content-center">
          <div class="col-9 px-0 text-center">
            <b-spinner
              v-if="loadingLayoutSearch"
              label="Loading"
              variant="primary"
            />
            <div v-else>
              <preview-layout
                v-if="currentPreviewSelected"
                ref="refPreviewLayout"
                :selected-layout="currentPreviewSelected.id"
                :slot-height="37"
                @get-user-layouts-finish="setCamerasProxyFromItem"
                @select-slot="onSelectSlot"
                @unselect-slot="onSelectSlot"
              />
              <div class="videoTour-view-preview-message" v-else>
                {{ $t('video_tour.preview_message') }}
              </div>
            </div>
          </div>
        </div>
        <p v-if="errors.layout" class="small text-danger">
          {{ errors.layout }}
        </p>
      </div>
    </div>
    <b-tabs
      v-model="tabIndex"
      align="center"
      nav-class="mt-2"
    >
      <b-tab>
        <template #title>
          Agregar cámaras manualmente
          <feather-icon
            class="ml-1"
            icon="VideoIcon"
            size="20"
          />
        </template>
        <cameras-from-list
          ref="refCamerasFromList"
          :cameras-selected="camerasSelected"
          :current-preview-selected="currentPreviewSelected"
          :errors="errors"
          :fields="fields"
          :loading-layout-search="loadingLayoutSearch"
          @clean-layout-items="cleanLayoutItems"
          @clear-cameras-selected="clearCamerasSelected"
          @find-slot-without-data="findSlotWithoutData"
          @remove-camera-from-table="removeCameraFromTable"
        />
      </b-tab>
      <b-tab >
        <template #title>
          Agregar cámaras desde Mapa
          <feather-icon
            class="ml-1"
            icon="MapPinIcon"
            size="20"
          />
        </template>
        <cameras-from-map
          ref="refCamerasFromMap"
          :cameras-selected="camerasSelected"
          :coordinates="coordinates"
          :current-preview-selected="currentPreviewSelected"
          :errors="errors"
          :get-description-sector="getDescriptionSector"
          :get-description-unit="getDescriptionUnit"
          :fields="fields"
          :full-slots="fullSlots"
          @add-coordinates="addCoornidates"
          @clean-layout-items="cleanLayoutItems"
          @remove-camera-from-table="removeCameraFromTable"
          @set-cameras-selected-from-map="setCamerasSelectedFromMap"
        />
      </b-tab>
    </b-tabs>
     <!-- ================= Map ==============  -->
        <!--<camera-map v-if="!loadingUnitsStatus" v-model="mapConfig" @camera-selection="onMapCameraSelection" />
        <div v-else>
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>-->
    <!-- <div class="row mx-0">
      <div class="col-5 pl-0">
        <span class="font-weight-bold h5 videoTourDualListTitle">
          Lista de cámaras
        </span>

        <b-input-group class="w-100 my-1">
          <b-input-group-prepend is-text>
            <i class="feather icon-search"></i>
          </b-input-group-prepend>

          <b-form-input
            id="searchView"
            v-model="viewsSearchCamera"
            trim
            :placeholder="$t('search')"
            @input="onTypeSearchCamera"
          />
        </b-input-group>
        <div class="row mb-1">
          <div class="col">
            <v-select
              label="name"
              v-model="centerFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="centerOptions"
              :reduce="(val) => val.id"
              input-id="id_center"
              placeholder="Buscar por centro"
              @input="changeCenter"
            />
          </div>
          <div class="col">
            <v-select
              label="name"
              v-model="sectorFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sectorOptions"
              :reduce="(val) => val.id"
              input-id="id_sector"
              placeholder="Buscar por sector"
            />
          </div>
          <div class="col">
            <v-select
              label="name"
              v-model="categoryFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="categoryOptions"
              :reduce="(val) => val.id"
              input-id="id_category"
              placeholder="Buscar por categoría"
            />
          </div>
        </div>
        <b-list-group class="mb-1 list-cameras">
          <b-list-group-item
            v-for="(cameraProxy, index) in visibleCameras"
            :key="index"
            class="d-flex justify-content-between align-items-center"
            button
            :disabled="selectCamerasDisabled"
            v-show="canShowCamera(cameraProxy)"
            @click="setCamera(cameraProxy)"
          >
            {{ cameraProxy.camera.name }}
            <div>
              <b-badge v-if="getDescriptionSector(cameraProxy.camera)" style="margin-right: 5px;">
                {{ getDescriptionSector(cameraProxy.camera) }}
              </b-badge>
              <b-badge v-if="getDescriptionUnit(cameraProxy.camera)" variant="primary">
                {{ getDescriptionUnit(cameraProxy.camera) }}
              </b-badge>
            </div>
          </b-list-group-item>
        </b-list-group>
        <pagination-widgets
          :sidebarMinWidthReached="false"
          :per-page.sync="camerasPerPage"
          :records-per-page="camerasPerPageOptions"
          :current-page.sync="camerasCurrentPage"
          :total-records="camerasProxyTotalRecords"
          @update:currentPage="updateCamerasCurrentPage"
          @update:perPage="updateCamerasPerPage"
        />
      </div>
      <div class="col-1 align-self-center text-center">
        <b-button
          variant="primary"
          class="p-0"
          :disabled="selectCamerasDisabled"
          @click="addAllCameras()"
        >
          <feather-icon
            icon="ChevronRightIcon"
            size="40"
          />
        </b-button>
       </div>
      <div class="col-6 align-self-start ">
        <span class="font-weight-bold h5 videoTourDualListTitle">
          Cámaras seleccionadas
        </span>
        <b-alert
          v-if="!camerasSelected.length"
          show
          variant="warning"
          class="p-1 mt-1"
        >
          Sin cámaras seleccinadas
        </b-alert>
        <b-table
          v-else
          class="mt-1"
          :items="camerasSelected"
          :fields="fields"
          sticky-header
        >
          <template #cell(camera.units)="data">
            {{ getDescriptionUnit(data.item.camera) }}
          </template>

          <template #cell(camera.sector)="data">
            {{ getDescriptionSector(data.item.camera) }}
          </template>

          <template #cell(actions)="data">
            <b-button
              variant="danger"
              size="sm"
              @click="removeCameraFromTable(data.item,data.index)"
            >
              <feather-icon icon="XIcon" />
            </b-button>
          </template>
        </b-table>
        <p v-if="errors.cameras" class="small text-danger">
          {{ errors.cameras }}
        </p>
      </div>
    </div> -->
  </b-modal>
</template>

<script>
import axios from "@axios";
import { v4 as uuid } from "uuid";
import { computed,nextTick,ref,watch } from '@vue/composition-api';
import { debounce } from "lodash";
import LayoutPreview from "../LayoutPreview";
import PaginationWidgets from "../components/PaginationWidgets.vue";
import PreviewLayout from '@/views/alarm_views/layout/PreviewLayout.vue';
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { SLOT_TYPES } from "@/config/layoutConfig";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import store from '@/store';
import CameraMap from "@/views/components/GridView/widgets/ViewsWidget/widgets/CameraMap.vue";
import CamerasFromList from "./CamerasFromList.vue";
import CamerasFromMap from "./CamerasFromMap.vue";

export default {
  props: {
    item: {
      type: Object
    },
    showModal:{
      type: Boolean
    }
  },
  components: {
    CamerasFromList,
    CamerasFromMap,
    CameraMap,
    LayoutPreview,
    PaginationWidgets,
    PreviewLayout,
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  setup (props, { emit }) {
    //COMPOSABLES
    const toast = useToast();

    //DATA
    const camerasCurrentPage = ref(1);

    const camerasExcludedFilter = ref([]);

    const camerasSelected = ref([]);

    const camerasPerPage = ref(4);

    const camerasProxy = ref([]);

    const camerasProxyTotalRecords = ref(0);

    const camerasSearch = ref('');

    const categoryFilter = ref(null);

    const centerFilter = ref(null);

    const coordinates = ref(null);

    const currentPreviewSelected = ref(null);

    const errors = ref({
      cameras: null,
      layout: null
    });

    const fields = ref([
      {
        key: 'actions',
        label: 'Seleccionar'
      },
      {
        key:'camera.name',
        label: 'Nombre'
      },
      {
        key: 'camera.units',
        label: 'Instalación'
      },
      {
        key: 'camera.sector',
        label: 'Sector'
      },
    ]);

    const idUserView = ref(null);

    const isAdd = ref(true);

    const loadingCameras = ref(false);

    const loadingUserViews = ref(false);

    const layouts = ref([]);

    const layoutsViewsTotalRecords = ref(0);

    const layoutsCurrentPage = ref(1);

    const layoutsPerPage = ref(3);

    const layoutsPerPageCamera = ref(3);

    const layoutsSearch = ref('');

    const loading = ref(false);

    const loadingLayoutSearch = ref(false);

    const sectorFilter = ref(null);

    const sectorOptions = ref([]);

    const showSendToValidationButton = ref(false);

    const slotsLayoutSelected = ref(0);

    const refCamerasFromList = ref(null);

    const refCamerasFromMap = ref(null);

    const refPreviewLayout = ref(null);

    const tabIndex = ref(0);

    const uuidRef = uuid;

    const viewsSearchCamera = ref('');

    //COMPUTED
    const buttonText = computed(() => props.item.id ? 'Editar': 'Guardar');

    const camerasPerPageOptions = computed(() => [
      (camerasPerPage.value * 1),
      (camerasPerPage.value + 4),
      (camerasPerPage.value + 8)
    ]);

    const categoryOptions = computed(() => store.getters['facility_category/getItems']);

    const centerOptions = computed(() => store.getters['center/getItems']);

    const fullSlots = computed(() => (refPreviewLayout.value) && (refPreviewLayout.value.slots.length === camerasSelected.value.length));

    const localIsActive = computed({
      get() {
        return props.showModal;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    const layoutItems = computed(() => store.getters["alarm_views/layoutItems"]);

    const modalTitle = computed(() => props.item.id ? 'Editar vista': 'Agregar vista');

    const selectCamerasDisabled = computed(() => (!currentPreviewSelected.value) || (loadingCameras.value) || (loadingLayoutSearch.value));

    const showAlert = computed(() => (props.item.last_status) && (props.item.last_status.status.name === 'in_review') && (props.item.id));

    const showSubmitButton = computed(() => {
      if (isAdd.value && showSendToValidationButton.value) {
        return false;
      } else if (!isAdd.value && props.item.last_status && (props.item.last_status.status.name === 'in_review')) {
        return false
      } else {
        return true;
      }
    });

    const visibleCameras = computed(() => {
      return camerasProxy.value.filter(cameraProxy => {
        return !camerasExcludedFilter.value.includes(cameraProxy.id);
      });
    });

    const user = computed(() => store.getters["user/getUser"]);

    // Map ===================================================
    const units = computed(() => store.state.grid.units);
    const loadingUnitsStatus = computed(() => store.state.grid.loadingUnits);
    const mapConfig = ref({
      lat: 19.442217319074633,
      lng: -99.12301328580936,
      radius: 10.0, // mts
      zoom: 8,
    });

    //METHODS
    const addAllCameras = async () => {
      cleanLayoutItems();

      camerasSelected.value = [];
      camerasExcludedFilter.value = [];

      camerasProxy.value.forEach(camera => {
        setCamera(camera);
      });

      await getCamerasProxy();
    }

    const addCoornidates = (coordinatesData) => {
      if (tabIndex.value === 1) {
        coordinates.value = {
          ...coordinatesData
        }
      }
    }

    const addPreview = (layout) => {
      currentPreviewSelected.value = layout;
    }

    const canShowCamera = (camera) => {
      const indexCamera = getCameraIndex(camera);

      return (indexCamera !== -1);
    }

    const changeCenter = (centerId) => {
      sectorFilter.value = null;

      const centerFiltered = centerOptions.value.find(
        center => center.id === centerId
      );

      sectorOptions.value = centerFiltered?.sectors || [];
    }

    const changePreviewWithItems = () => {
      if (layoutItems.value.length) {
        const layoutItemsLength = layoutItems.value.length;
        const slotsLayoutPreviewLength = refPreviewLayout.value.slots.length;

        if (slotsLayoutPreviewLength < layoutItemsLength) {
          const newCameraDataSelected = layoutItems.value.slice(0, slotsLayoutPreviewLength);
          const camerasNotSelected = layoutItems.value.slice(slotsLayoutPreviewLength);

          if (newCameraDataSelected.length) {
            setNewCamerasSelected(newCameraDataSelected);
          }

          if (camerasNotSelected.length) {
            removeItemsLayout(camerasNotSelected);
          }
        }

        layoutItems.value.forEach(item => {
          let slotByPos = refPreviewLayout.value.slots.find(
            slot => (slot.pos === item.pos)
          );

          if (slotByPos) {
            slotByPos.data = item.data;
            slotByPos.name = item.name;
            slotByPos.type = (item.data) ? item.type : null;
          }
        });
      }
    }

    const clearCamerasSelected = () => {
       camerasSelected.value = [];
    }

    const cleanErrors = () => {
      errors.value = {
        cameras: null,
        layout: null
      }
    }

    const cleanLayoutItems = () => {
      store.dispatch('alarm_views/emptyLayoutItems');
    }

    const findSlotWithoutData = (camera, isEdit, indexSlotEdit) => {
      const dataSlotLayout = getDataSlot(camera);
      const nameSlotLayout = (camera) ? camera.camera.name : '';

      const slotData = {
        type: SLOT_TYPES.CAM_LIVE,
        name: '',
        data: dataSlotLayout
      }

      refPreviewLayout.value.findSlotWithoutData(slotData, isEdit, indexSlotEdit);
    }

    const getCamerasProxy = async function () {
      loadingCameras.value = true;

      const params = {
        q: camerasSearch.value,
        max: camerasPerPage.value,
        'page[n]': camerasCurrentPage.value,
        with: ['units'],
        camerasOnly: true,
        id_center: centerFilter.value,
        id_sector: sectorFilter.value,
        id_category: categoryFilter.value,
        camerasExcluded: camerasExcludedFilter.value
      }

      const { data } = await axios.get('v1/proxy_camera', { params });

      if (!data.success) return;

      camerasProxy.value = data.data.filter(cp => cp.camera);
      camerasProxyTotalRecords.value = data.meta.total;
      loadingCameras.value = false;
    }

    const getCameraIndex = (dataCamera) => {
      if (!dataCamera) {
        return -1;
      }

      const index = camerasSelected.value.findIndex(
        camera => (camera.id === dataCamera.id)
      );

      return index;
    }

    const getDataSlot = (camera) => {
      if (!camera) {
        return null;
      }

      const dataSlot = {
        ...camera,
        in_app_source	:	'subsystem_tree'
      }

      return dataSlot;
    }

    const getDescriptionSector = (camera) => {
      if (!camera.units.length) {
        return null;
      }

      const [unit] = camera.units;
      const { sector } = unit;

      if (!sector) {
        return null;
      }

      return sector.name;
    }

    const getDescriptionUnit = (camera) => {
      if (!camera.units.length) {
        return null;
      }

      const [unit] = camera.units;
      const { description } = unit;

      return description;
    }

    const getLayout = async (layoutId) => {
      loadingLayoutSearch.value = true;

      const { data }   = await axios.get(`v1/layout/${layoutId}`);

      if (data.data) {
        addPreview(data.data);
      }

      loadingLayoutSearch.value = false;
    }

    const getLayouts = async function () {
      loadingUserViews.value = true;

      const params = {
        q: layoutsSearch.value,
        max: layoutsPerPage.value,
        "page[n]": layoutsCurrentPage.value
      }

      const { data } = await axios.get('v1/layout', { params });

      if (!data.success) return;

      layouts.value = data.data;
      layoutsViewsTotalRecords.value = data.meta.total;
      loadingUserViews.value = false;
    }

    const onHide = () => {
      cleanLayoutItems();

      slotsLayoutSelected.value = 0;
      currentPreviewSelected.value = null;
      camerasSelected.value = [];
      camerasExcludedFilter.value = [];
      camerasPerPage.value = 4;
      camerasCurrentPage.value = 1;
      layoutsPerPage.value = 3;
      layoutsCurrentPage.value = 1;
      coordinates.value = null;
      tabIndex.value = 0;

      emit('clean-item');
      emit('update:isActive', false);

      cleanErrors();
    }

    const onSelectSlot = (slots, widget = null) => {
      const slotsSelectedFiltered = slots.filter(slot => {
        if (!slot.data) {
          return false;
        }

        const slotDataObjectEntries = Object.entries(slot.data);
        const slotObejectHasProperties = slotDataObjectEntries.length;

        if (!slotObejectHasProperties) {
          return false;
        }

        return slot;
      });

      slotsLayoutSelected.value = slotsSelectedFiltered.length;

      if (widget) {
        removeCamera(widget.data);
      }
    }

    const onShow = async () => {
      const canShowSendToVlidationButton = (props.item.id) && (!props.item.last_status || props.item.last_status.status.name === 'in_progress');

      showSendToValidationButton.value = canShowSendToVlidationButton;

      if (props.item.id) {
        const { layout } = props.item.data;

        isAdd.value      = false;
        idUserView.value = props.item.id;

        if (props.item.user_views_validation) {
          props.item.is_public = props.item.user_views_validation.data.is_public;
        } else {
          props.item.is_public = (props.item.id_user) ? false : true;
        }

        const coordinates =  (props.item.id && props.item.user_views_validation)
        ? props.item.user_views_validation.data.coordinates
        : props.item.coordinates;

        if (coordinates) {
          tabIndex.value = 1;
          addCoornidates(coordinates);
        } else {
          tabIndex.value = 0;

          camerasExcludedFilter.value = props.item.data.slots.filter(
            slot => (!Array.isArray(slot.data)) && (slot.data)
          )
          .map(slot => slot.data.id);
        }

        await getLayout(layout);
      }

      await getLayouts();
    }

    const onSubmit = async () => {
      cleanErrors();

      if (!refPreviewLayout.value) {
        errors.value.layout = 'No se ha seleccionado algun layout';

        return
      }

      if (!camerasSelected.value.length) {
        errors.value.cameras = 'No se han seleccionado cámaras';

        return
      }

      const uuid = uuidRef();
      const { layout,slots } = refPreviewLayout.value;
      const methodRequest    = (props.item.id) ? 'put' : 'post';
      const urlRequest       = (props.item.id) ? `v1/user-views/${props.item.id}` : 'v1/user-views';

      props.item.tabId = (props.item.id) ? props.item.data.id : uuid;
      props.item.data.name = props.item.name;
      props.item.data.gridItems = layout.grid;
      props.item.data.id        = (props.item.id) ? props.item.data.id : uuid;
      props.item.data.layout    = layout.id;
      props.item.data.order     = 1;
      props.item.data.slots     = slots;
      props.item.data.type      = 'view';
      props.item.data.is_public = props.item.is_public;
      props.item.data.id_user   = user.value.id;
      props.item.data.coordinates = (tabIndex.value === 1) ? coordinates.value : null;
      props.item.is_camera_view = true;
      props.item.coordinates    = (tabIndex.value === 1) ? coordinates.value : null;

      loading.value = true;

      await axios[methodRequest](urlRequest, props.item)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });

          if (!props.item.id) {
            idUserView.value = data.data.id;
          }

          showSendToValidationButton.value = true;

          emit('refresh');
        })
        .catch((error) => {
          const { message = 'error' } = error .response.data;

          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const onTypeSearch = debounce(async function (search) {
      layoutsSearch.value = search;

      await getLayouts();
    }, 800);

    const onTypeSearchCamera = debounce(async function (search) {
      viewsSearchCamera.value = search;

      await getCamerasProxy();
    }, 800);

    const removeCamera = (camera) => {
      if (tabIndex.value === 1) {
        refCamerasFromMap.value.findCameraForDisabled(camera.id);
      }

      const indexCamera = getCameraIndex(camera);

      if (indexCamera !== -1) {
        camerasSelected.value.splice(indexCamera, 1);

        removeCameraExcluded(camera.id);
      }
    }

    const removeCameraExcluded = async (cameraId) => {
      const indexCameraExcluded = camerasExcludedFilter.value.findIndex(
        id => (cameraId === id)
      );

      camerasExcludedFilter.value.splice(indexCameraExcluded, 1);

      await getCamerasProxy();
    }

    const removeCameraFromTable = (camera) => {
      const indexSlot = refPreviewLayout.value.slots.findIndex(
        slot => !Array.isArray(slot.data) && (slot.data.id === camera.id)
      );

      if (indexSlot !== -1) {
        const slotRemove = refPreviewLayout.value.slots[indexSlot];
        const refKey     = `slot-${(indexSlot + 1)}`;
        const [refSlot]  = refPreviewLayout.value.$refs[refKey];

        refSlot.removeItemFromSlot(slotRemove);
      }
    }

    const removeItemsLayout = (camerasNotSelected) => {
      camerasNotSelected.forEach(cameraNotSelected => {
        const { pos } = cameraNotSelected;

        store.dispatch('alarm_views/removeLayoutItem', pos);
      });
    }

    const sendToValidation = async () => {
      loading.value = true;

      await axios.get(`v1/user-views/${idUserView.value}/send-to-validation`)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });

          emit('refresh');
          emit('clean-item');
          emit('update:isActive', false);
        })
        .catch((error) => {
          const { message = 'error' } = error .response.data;

          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const setCamera = (camera, isEdit = false, indexSlotEdit = null) => {
      const indexCamera = getCameraIndex(camera);

      if (indexCamera === -1) {
        if (camera) {
          camerasSelected.value.push(camera);
          camerasExcludedFilter.value.push(camera.id);
        }

        findSlotWithoutData(camera, isEdit, indexSlotEdit);
      }
    }

    const setCamerasSelectedFromMap = (camera) => {
      const { add } = camera;
      const cameraData = {
        camera: {
          ...camera.camera
        },
        camera_type: camera.camera.camera_type,
        id: camera.camera.id
      }

      if (add) {
        setCamera(cameraData);
        return
      }

      removeCameraFromTable(cameraData);
    }

    const setCamerasProxyFromItem = async () => {
      if (tabIndex.value === 0) {
        const perPage = refPreviewLayout.value.slots.length;

        await refCamerasFromList.value.setCamerasProxyFromItem(perPage);
      }

      if (props.item.id) {
        nextTick(() => {
          const { data } = props.item;

          data.slots.forEach((slot, index) => {
            let camera = null;

            if (slot.data) {
              const isArrayData = Array.isArray(slot.data);

              camera = (!isArrayData) ? slot.data : null;
            }

            refCamerasFromList.value.setCamera(camera, true, index);
          });

          changePreviewWithItems();
        });

      } else {
        changePreviewWithItems();
      }
    }

    const setNewCamerasSelected = (newCameraDataSelected) => {
      camerasSelected.value = [];

      newCameraDataSelected.forEach(newCamera => {
        const { data } = newCamera;

        camerasSelected.value.push({
          camera: data.camera,
          camera_type: data.camera_type
        });
      });
    }

    const updateCamerasCurrentPage = async (page) => {
      camerasCurrentPage.value = page;

      await getCamerasProxy();
    }

    const updateCamerasPerPage = async (perPage) => {
      camerasPerPage.value = perPage;

      await getCamerasProxy();
    }

    const updateLayoutsCurrentPage = async (page) => {
      layoutsCurrentPage.value = page;

      await getLayouts();
    }

    const updateLayoutsPerPage = async (perPage) => {
      layoutsPerPage.value = perPage;

      await getLayouts();
    }

    // Map ===================================================
    /* const loadUnits = async () => {
      if (!loadingUnitsStatus.value && !units.value.length) {
        await store.dispatch("grid/getUnitsByTenant");
      }
    } */

    const onMapCameraSelection = (data) => {
      console.log('camera from map', data);
    }

    //WATCHERS
    watch(
      [centerFilter,sectorFilter,categoryFilter],
      async () => await getCamerasProxy()
    );

    return {
      camerasCurrentPage,
      camerasSelected,
      camerasProxy,
      camerasPerPage,
      categoryFilter,
      categoryOptions,
      centerFilter,
      changePreviewWithItems,
      coordinates,
      currentPreviewSelected,
      camerasProxyTotalRecords,
      camerasSearch,
      errors,
      fields,
      layoutsCurrentPage,
      layoutsPerPage,
      layoutsPerPageCamera,
      layouts,
      layoutsViewsTotalRecords,
      layoutsSearch,
      loading,
      loadingCameras,
      loadingLayoutSearch,
      refCamerasFromList,
      refCamerasFromMap,
      refPreviewLayout,
      tabIndex,
      sectorFilter,
      sectorOptions,
      showSendToValidationButton,
      viewsSearchCamera,

      buttonText,
      camerasPerPageOptions,
      centerOptions,
      cleanLayoutItems,
      fullSlots,
      localIsActive,
      modalTitle,
      selectCamerasDisabled,
      showAlert,
      showSubmitButton,
      visibleCameras,

      // Map ====================
      /* loadingUnitsStatus,
      mapConfig,
      onMapCameraSelection, */

      addAllCameras,
      addCoornidates,
      addPreview,
      canShowCamera,
      changeCenter,
      clearCamerasSelected,
      getDescriptionSector,
      getDescriptionUnit,
      getLayouts,
      findSlotWithoutData,
      onHide,
      onSelectSlot,
      onShow,
      onSubmit,
      onTypeSearch,
      onTypeSearchCamera,
      removeCameraFromTable,
      sendToValidation,
      setCamera,
      setCamerasSelectedFromMap,
      setCamerasProxyFromItem,
      updateCamerasCurrentPage,
      updateCamerasPerPage,
      updateLayoutsCurrentPage,
      updateLayoutsPerPage
    }
  }
}
</script>

<style scoped>
.list-cameras {
  height: 175px;
  overflow-y: auto;
}

.table-cameras-selected {
  max-height: 100px;
  overflow-y: auto;
}
</style>
